<div class="station-details">
  <sc-padding fitHeight>
    @if (station != null) {
      <sc-flex vertical fitHeight stretchContent>
        <sc-flex-fitting-content vertical>
          <sc-loading-spinner [isLoading]="isLoading" fitHeight>
            @if (stationDetailsView === stationDetailsViewValues.STATION_DISABLED) {
              <sc-padding [double]="true">
                {{'Bearbeitung ist momentan nicht möglich!' | translate:
                ['tmc-yard.action-tablet.station-transport-details.station-disabled', translationService.language,
                [station?.stationUsage?.note]]}}
              </sc-padding>
              <sc-flex stretchContent>
                <sc-content-spacer grow></sc-content-spacer>
                @if (station.stationUsage.suspended) {
                  <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
                  ></sc-icon>
                }
              </sc-flex>
            }
            @if (stationDetailsView !== stationDetailsViewValues.STATION_DISABLED) {
              <!-- <ng-container *ngIf="showTransportDetails"> -->
              <div class="transport-details" [ngClass]="{'ongoing-movement': station.stationUsage.ongoingMovementFromStation || station.stationUsage.ongoingMovementToStation}">
                <sc-flex vertical fitHeight stretchContent >
                  @if (showHeader) {
                    <div class="header">
                      <!-- BEGIN: HEADER -->
                      @if (stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_TO_STATION) {
                        <div>
                          <sc-padding>
                            <div class="title">
                              <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
                              <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.ongoingMovement"></sc-dictionary-label>
                            </div>
                          </sc-padding>
                          <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                        </div>
                      }
                      @if (stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_FROM_STATION) {
                        <div>
                          <div class="title">
                            <sc-flex stretchContent centered>
                              <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                              <sc-content-spacer></sc-content-spacer>
                              @if (transportDetails?.scope === 'SWAP_TRAILER') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer"></sc-dictionary-label>
                              }
                              @if (transportDetails?.scope === 'TRAILER') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer"></sc-dictionary-label>
                              }
                              @if (transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others"></sc-dictionary-label>
                              }
                            </sc-flex>
                          </div>
                          <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                        </div>
                      }
                      @if (stationDetailsView === stationDetailsViewValues.STATION_OCCUPIED) {
                        <div
                          >
                          <div class="title occupied">
                            <sc-flex  stretchContent centered>
                              <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                              @if (transportDetails?.scope === 'SWAP_TRAILER') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer"></sc-dictionary-label>
                              }
                              @if (transportDetails?.scope === 'TRAILER') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer"></sc-dictionary-label>
                              }
                              @if (transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK') {
                                <sc-dictionary-label dictionaryKey="tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others"></sc-dictionary-label>
                              }
                            </sc-flex>
                          </div>
                          <sc-content-spacer [double]="true" vertical></sc-content-spacer>
                        </div>
                      }
                      <!-- END: HEADER -->
                    </div>
                  }
                  <sc-flex-fitting-content vertical>
                    <div>
                      <sc-scroll-pane>
                        @if (showTransportDetails) {
                          <sc-padding>
                            <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
                              [transport]="transportDetails">
                            </app-transport-details>
                          </sc-padding>
                        }
                        @if (!showTransportDetails) {
                          <div>
                            <sc-flex [wrap]="true">
                              @for (reference of transportCreationProfiles; track reference) {
                                <app-action-tablet-transport-creation-profile-details [stationId]="stationId"
                                  [transportCreationProfile]="reference"
                                ></app-action-tablet-transport-creation-profile-details>
                              }
                            </sc-flex>
                          </div>
                        }
                      </sc-scroll-pane>
                    </div>
                  </sc-flex-fitting-content>
                  <div>
                    <sc-content-spacer vertical></sc-content-spacer>
                    <app-action-tablet-buttonbar [station]="station" [transportDetails]="transportDetails"
                    [defaultCompletionOption]="defaultCompletionOption"></app-action-tablet-buttonbar>
                  </div>
                </sc-flex>
              </div>
            <!-- </ng-container> -->
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-flex stretchContent>
              <sc-content-spacer grow></sc-content-spacer>
              @if (station.stationUsage.transports.length === 0 && !station.stationUsage.disabled && !station.stationUsage.loadingZoneLock) {
                <sc-icon iconClass="fa-lock" (click)="startSuspension()"
                ></sc-icon>
              }
            </sc-flex>
          }
        </sc-loading-spinner>
      </sc-flex-fitting-content>
    </sc-flex>
  }
</sc-padding>
